import React from 'react';
import Link from 'gatsby-link';

const Header = ({ layoutContext }) => (
  <menu className="menu">
    <Link to={`${layoutContext.pathPrefix}/${layoutContext.content.pages.index.url}`}>
      {layoutContext.content.pages.index.menuTitle}
    </Link>
    <Link to={`${layoutContext.pathPrefix}/${layoutContext.content.pages.services.url}`}>
      {layoutContext.content.pages.services.title}
    </Link>
    <Link to={`${layoutContext.pathPrefix}/${layoutContext.content.pages.contacts.url}`}>
      {layoutContext.content.pages.contacts.title}
    </Link>
  </menu>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Menu/index.jsx